// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2umS2","content":"styles_content__1q2JN","selectAll":"styles_selectAll__2q2_a"};